import { Component, Input, OnInit, Self, Optional } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, NgControl } from '@angular/forms';

@Component({
  selector: 'form-textarea',
  templateUrl: './textarea.component.html',

})
export class TextareaComponent implements OnInit, ControlValueAccessor {
  @Input() icon: string;
  @Input() name: string;
  @Input() placeholder: string;
  @Input() label: string;
  @Input() required = false;
  @Input() readonly = false;
  @Input() disabled = false;
  @Input() autofocus = false;
  @Input() data: string;
  @Input() rows = 5;
  @Input()
  get value(): string {    
    if (!this._value) {
      return '';
    } else {
      return this._value;
    }
  };
  set value(value: string) {
    this._value = value;    
  }

  private _value = '';

  // It will have a reference to a function that handles changing state of the control
  private _onChangeFn: (value: any) => void = _ => { };

  constructor(@Self() @Optional() public ngControl: NgControl) {

    this.ngControl.valueAccessor = this;
  }

  ngOnInit() {

  }

  onChange(event) {
    this.value = event.target.value;
    this._onChangeFn(this.value);
  }

  writeValue(value: any) {
    this.value = value;
  }


  registerOnChange(fn) { this._onChangeFn = fn }

  // TODO: Implement this
  registerOnTouched(fn) { }
  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

}
